import React, { useEffect, useState } from 'react';
import { Box, Typography, Divider, CircularProgress } from '@mui/material';
import axios from 'axios';

export default function LetterPreview({ letterId, firmInfo }) {
  const [letter, setLetter] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!letterId) { setLoading(false); return; }
    const token = localStorage.getItem('access_token');
    axios.get(`/api/letters/${letterId}/`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setLetter(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [letterId]);

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress size={24} /></Box>;
  if (!letter) return null;

  const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <Box
      sx={{
        fontFamily: 'Georgia, serif',
        fontSize: 13,
        lineHeight: 1.7,
        color: 'text.primary',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        p: 4,
        maxWidth: 680,
        mx: 'auto',
      }}
    >
      {/* Letterhead */}
      {firmInfo && (
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ fontSize: 18, fontWeight: 700, color: 'primary.main', fontFamily: 'inherit' }}>
            {firmInfo.firm_name || firmInfo.name}
          </Typography>
          {firmInfo.address && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
              {[firmInfo.address, firmInfo.city, firmInfo.state, firmInfo.zip_code].filter(Boolean).join(', ')}
            </Typography>
          )}
          {(firmInfo.phone || firmInfo.email) && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
              {[firmInfo.phone, firmInfo.email, firmInfo.website].filter(Boolean).join(' | ')}
            </Typography>
          )}
        </Box>
      )}

      <Divider sx={{ borderColor: 'primary.main', borderWidth: 1.5, mb: 2 }} />

      {/* Date */}
      <Typography sx={{ textAlign: 'right', fontSize: 12, mb: 2, fontFamily: 'inherit' }}>
        {today}
      </Typography>

      {/* Client address */}
      {letter.client_name && (
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ fontFamily: 'inherit', fontSize: 13 }}>{letter.client_name}</Typography>
        </Box>
      )}

      {/* Subject */}
      {letter.title && (
        <Typography sx={{ fontWeight: 700, fontSize: 13, mb: 1.5, fontFamily: 'inherit' }}>
          Re: {letter.title}
        </Typography>
      )}

      <Divider sx={{ mb: 2 }} />

      {/* Body */}
      <Box
        sx={{ '& p': { mb: 1.5 }, '& ul, & ol': { pl: 3, mb: 1.5 }, '& li': { mb: 0.5 } }}
        dangerouslySetInnerHTML={{ __html: letter.content_html || '<p><em>(No content)</em></p>' }}
      />

      {/* Signature block */}
      <Box sx={{ mt: 4 }}>
        <Typography sx={{ fontFamily: 'inherit', fontSize: 13 }}>Sincerely,</Typography>
        <Box sx={{ mt: 3 }}>
          <Typography sx={{ fontWeight: 700, fontFamily: 'inherit', fontSize: 13 }}>
            {letter.created_by_name || ''}
          </Typography>
          {firmInfo && (
            <Typography sx={{ fontFamily: 'inherit', fontSize: 12, color: 'text.secondary' }}>
              {firmInfo.firm_name || firmInfo.name}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}
